import { render } from "./GameStory.vue?vue&type=template&id=7af8b317"
import script from "./GameStory.vue?vue&type=script&lang=js"
export * from "./GameStory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__